module.exports = __webpack_public_path__ + "assets/img/m702-badge-1.0b3a37e9.png";